import { render } from "./KryptonLoadingAnimation.vue?vue&type=template&id=4c3b1480&lang=pug"
import script from "./KryptonLoadingAnimation.vue?vue&type=script&lang=js"
export * from "./KryptonLoadingAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__